import gql from 'graphql-tag'

export const SET_SECTION = gql`
  mutation setSection($id: String, $state: String) {
    section(id: $id, state: $state) @client
  }
`

export const CLEAR_SECTION = gql`
  mutation clearSection {
    section(id: null, state: null) @client
  }
`

export const GET_SECTION = gql`
  query {
    section @client {
      id,
      state
    }
  }
`

export const SET_INSERT_SCRIPT_PENDING = gql`
  mutation setInsertScriptPending($isPending: Boolean) {
    setInsertScriptRes(isPending: $isPending) @client
  }
`

export const SET_INSERT_SCRIPT_RES = gql`
  mutation setInsertScriptRes($isPending: Boolean, $error: String) {
    setInsertScriptRes(isPending: $isPending, error: $error) @client
  }
`

export const GET_INSERT_SCRIPT_RES = gql`
  query {
    insertScriptRes @client {
      isPending
      error
    }
  }
`

export const SET_CURSOR_POSITION = gql`
  mutation setCursorPosition($sectionId: String, $cursorPositionIndex: Int, $location: String) {
    setCursorPosition(sectionId: $sectionId, cursorPositionIndex: $cursorPositionIndex, location: $location) @client
  }
`

export const GET_CURSOR_POSITION = gql`
  query {
    cursorPositions @client {
      sectionId
      cursorPositionIndex
      location
    }
  }
`

export const SET_CURSOR_ACKNOWLEDGED = gql`
  mutation setCursorAcknowledged($isAcknowledged: Boolean) {
    setCursorAcknowledged(isAcknowledged: $isAcknowledged) @client
  }
`

export const GET_CURSOR_ACKNOWLEDGED = gql`
  query {
    cursorAcknowledged @client
  }
`

export const SET_CONTENT_TO_INSERT = gql`
  mutation setContentToInsert($sections: String) {
    setContentToInsert(contentToInsert: $sections) @client
  }
`

export const GET_CONTENT_TO_INSERT = gql`
  query {
    contentToInsert @client
  }
`
